import React, {useState, useEffect} from 'react';
import styled, {css} from 'styled-components';

import {Column, Row} from '@bootcamp/web/src/components/Grid';
import {GutterColumn} from '@bootcamp/web/src/components/Spacing';
import ButtonBar from '@bootcamp/web/src/components/ButtonBar';
import QuestionView from '@bootcamp/web/src/components/QuestionView';
import Exhibit from '@bootcamp/web/src/components/Exhibit';
import {useDocumentTitle} from '@bootcamp/shared/src/util/hooks';
import QBank from '@bootcamp/web/src/components/QBank';
import {TestNavigatorProvider, useTestNavigatorContext} from '../../../contexts/TestNavigator';
import {QuestionSearchProvider, useQuestionSearchContext} from './context';

import baseTheme from '@bootcamp/shared/src/styles/theme';


const BankWrapper = () => {
  const {methods: {setTest, syncQuestionSearchProgress}, variables: {test}} = useTestNavigatorContext();
  const {getResults, results, hasNextPage, loadNextPage} = useQuestionSearchContext();

  const handleSearch = async (value, nextPage) => {
    if (!value && nextPage) {
      return hasNextPage && await loadNextPage();
    }
    try {
      return await getResults(value);

    } catch (error) {
      console.log('error searching', error);
    }
  };

  useEffect(() => {

    if (!test) return;

    let updatedTest = test;

    const formattedResults = results.map((result, index) => {
      return {
        index,
        question: result
      };
    });

    updatedTest.blockConnections.items[1].testBlock.questionConnections.items = formattedResults;

    setTest(updatedTest);
    syncQuestionSearchProgress(updatedTest);

  }, [results, test])

  return (
    <QBank
      themePalette={baseTheme.colors.brandPalette.indigo}
      onSearch={handleSearch}
      hideSidebarSettings
    />
  );
}

const UpdatedSearch = ({match}) => {
  const testId = 'question-search-test';
  const progressId = 'question-search-progress';
  useEffect(() => {
    // set document title
    document.title = 'Bootcamp.com | Question Search';
  }, []);
  return (
    <TestNavigatorProvider
      template={'questionSearchBank'}
      match={match} testId={testId} progressId={progressId}
      skipStartBlock
      enableReloadBlocker={false}
    >
      <QuestionSearchProvider>
        <BankWrapper
          themePalette={baseTheme.colors.brandPalette.indigo}
          />
      </QuestionSearchProvider>
    </TestNavigatorProvider>
  );
}



export default UpdatedSearch;
